import React, { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';

import styles from './GRLinkCard.module.less';
import androidImg from '../../static/game/smallAndroid.png';
import DLCImg from '../../static/game/smallDLC.png';
import GameRate from '../GameRate/GameRate';
import Button from '../Button/Button';
import { formatMoney } from '../../utils/utils';
import { CONTEXT } from '../../config';

export default memo(({ soft }) => {
  const formatDiscount = (current, original) => {
    let cp = parseFloat(current);
    let op = parseFloat(original);
    if (cp > 0 && op > 0) {
      let discont = parseFloat((cp / op) * 10).toFixed(1);
      if (discont.indexOf('.0') > -1) {
        return discont.slice(0, discont.length - 2);
      }
      return discont;
    }
    return '0';
  };

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);

  return (
    <div className={styles.card}>
      <Link
        to={
          soft?.androidType === '1'
            ? `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`
            : `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`
        }
        className="soft_left"
      >
        <div className="icon">
          <img src={soft?.logoFile} className="icon_img" />
          {soft.androidType === '1' && <img className="small_game_icon" src={androidImg} />}
          {soft.installFileType === 1 && soft.androidType !== '1' && (
            <img className="small_game_icon" src={DLCImg} />
          )}
        </div>
        <div className="soft_info">
          <div className="soft_title">{soft?.softName}</div>
          <div className="soft_introduction">{soft?.introduction}</div>
        </div>
      </Link>

      <div className="soft_size">
        <div>{soft?.installFileSize}</div>
      </div>
      <div className="soft_score">
        <GameRate score={(Number(soft.score) / 20).toFixed(1)} />
        <div className="score">{(Number(soft.score) / 20).toFixed(1)}</div>
      </div>
      <div className="soft_btn">
        <Button soft={soft} info={{ btnStyle: 'black', className: styles.btn }} />
        {soft?.payType === 1 && (
          <div className="soft_price">
            {soft?.originalPrice &&
              soft?.currentPrice &&
              soft?.originalPrice !== soft?.currentPrice && (
                <>
                  <div className={`soft_buyInfos_zk`}>
                    {formatDiscount(soft?.currentPrice, soft?.originalPrice)}折
                  </div>
                  <div className={`soft_buyInfos_cp`}>
                    <span className={`soft_buyInfos_cp_1`}>¥</span>
                    <span className={`soft_buyInfos_cp_2`}>
                      {formatMoney(parseFloat((soft?.currentPrice || 0) / 100))}
                    </span>
                  </div>
                  <div className={`soft_buyInfos_op`}>
                    {`¥${formatMoney(parseFloat((soft?.originalPrice || 0) / 100))}`}
                  </div>
                </>
              )}

            {((!soft?.originalPrice && soft?.currentPrice) ||
              (soft?.originalPrice && !soft?.currentPrice) ||
              (soft?.originalPrice &&
                soft?.currentPrice &&
                soft?.originalPrice === soft?.currentPrice)) && (
              <>
                <div className={`soft_buyInfos_cp`}>
                  <span className={`soft_buyInfos_cp_1`}>¥</span>
                  <span className={`soft_buyInfos_cp_2`}>
                    {formatMoney(
                      parseFloat((soft?.currentPrice || soft?.originalPrice || 0) / 100),
                    )}
                  </span>
                </div>
              </>
            )}
          </div>
        )}
        {soft?.androidType === '3' && soft?.sourceInfo && soft?.sourceInfo?.sellInfo && (
          <div className="soft_price">
            {soft?.sourceInfo?.sellInfo?.discount && (
              <div className="soft_buyInfos_zk">{soft?.sourceInfo?.sellInfo?.discount} 折</div>
            )}
            <div className={styles.soft_buyInfos}>
              {soft?.sourceInfo?.sellInfo?.currentPrice ===
                soft?.sourceInfo?.sellInfo?.originalPrice && (
                <>
                  {soft?.sourceInfo?.sellInfo?.currentPrice &&
                    !soft?.sourceInfo?.sellInfo?.originalPrice && (
                      <div>¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}</div>
                    )}
                  {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                    soft?.sourceInfo?.sellInfo?.originalPrice && (
                      <div>¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}</div>
                    )}
                  {soft?.sourceInfo?.sellInfo?.currentPrice &&
                    soft?.sourceInfo?.sellInfo?.originalPrice && (
                      <div>¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}</div>
                    )}
                </>
              )}
            </div>

            {soft?.sourceInfo?.sellInfo?.currentPrice !==
              soft?.sourceInfo?.sellInfo?.originalPrice && (
              <>
                {soft?.sourceInfo?.sellInfo?.currentPrice &&
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                    <>
                      <div className={`soft_buyInfos_cp`}>
                        <span className={`soft_buyInfos_cp_1`}>¥</span>
                        <span className={`soft_buyInfos_cp_2`}>
                          {formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                        </span>
                      </div>
                      <div className={`soft_buyInfos_op`}>
                        ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                      </div>
                    </>
                  )}
                {soft?.sourceInfo?.sellInfo?.currentPrice &&
                  !soft?.sourceInfo?.sellInfo?.originalPrice && (
                    <div className={`soft_buyInfos_cp`}>
                      <span className={`soft_buyInfos_cp_1`}>¥</span>
                      <span className={`soft_buyInfos_cp_2`}>
                        {formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                      </span>
                    </div>
                  )}
                {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                    <div className={`soft_buyInfos_cp`}>
                      <span className={`soft_buyInfos_cp_1`}>¥</span>
                      <span className={`soft_buyInfos_cp_2`}>
                        {formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                      </span>
                    </div>
                  )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
});
